<template>
  <!-- ケアオーケストレーターディーラーユーザー管理 -->
  <div id="CODealerSettingUser">
    <div id="container-center">
      <coSettingNavi :pageid='"CODealerSettingUser"' :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' :certificationFlag='this.certificationFlag' :searchConditions='this.searchConditions'></coSettingNavi>
      <settingUser :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId'  />
    </div>
    <div style="margin-top:10px;">
        <b-button class="backbutton is-primary" @click="back">戻る</b-button>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/guest/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/guest/careorchestrator/setting/ExternalUserContents";

export default {
  name: "CODealerSettingUser",
  methods: {
    back:  function() {
      this.$router.push({ 
        name: "CODealerHospitalSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
  },
  data() {
    var searchConditions = this.$route.params["searchConditions"];
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    return {
      searchConditions: searchConditions,
      certificationFlag: certificationFlag,
      careOrchestratorInstitutionId: careOrchestratorInstitutionId
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    settingUser: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/CODealerSettingUser.vue